/* ============================================================
   Personalisatie-validatie — ikenmijnmama.com
   ------------------------------------------------------------
   Blokkeert de add-to-cart-submit van het productformulier
   ALLEEN wanneer een "met naam"/"Ja ..."-variant is gekozen en:
     (a) het naamveld (properties[...naam...]) leeg is, of
     (b) een zichtbare personalisatie-dropdown nog op
         "Kies een optie" (lege waarde) staat, of
     (c) een zichtbare radiogroep (bijv. Kleur borduring)
         nog geen keuze heeft.
   Bij "Zonder naam"/"Nee" wordt niets afgedwongen.
   Volledig additief: raakt geen bestaande code aan.
   ============================================================ */
(function () {
  'use strict';

  if (window.__ikmmPersValidatieGeladen) return;
  window.__ikmmPersValidatieGeladen = true;

  var MSG_NAAM = 'Vul de naam in voor de borduring';
  var MSG_KEUZE_PREFIX = 'Maak nog een keuze bij: ';

  /* ---------- styling (via JS geïnjecteerd, geen css-bestand nodig) ---------- */
  function injectStyles() {
    if (document.getElementById('ikmm-pv-styles')) return;
    var css = ''
      + '.ikmm-pv-fout{color:#c0392b;font-size:13px;line-height:1.4;margin:6px 0 2px;display:block;}'
      + '.ikmm-pv-veld-fout{border:1px solid #c0392b !important;outline:1px solid #c0392b !important;border-radius:4px;}'
      + '.ikmm-pv-item-fout{box-shadow:inset 0 0 0 1px #c0392b;border-radius:6px;padding:4px;}';
    var style = document.createElement('style');
    style.id = 'ikmm-pv-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---------- helpers ---------- */
  function isZichtbaar(el) {
    if (!el) return false;
    var doel = (el.type === 'radio' || el.type === 'checkbox')
      ? (el.closest('.product-form__item') || el.parentElement || el)
      : el;
    if (doel.closest('[hidden]')) return false;
    // offsetParent is null bij display:none (of fixed); extra check via getClientRects
    if (doel.offsetParent !== null) return true;
    return doel.getClientRects && doel.getClientRects().length > 0;
  }

  function propertyNaam(el) {
    var m = /properties\[(.+?)\]/.exec(el.getAttribute('name') || '');
    return m ? m[1].trim() : '';
  }

  function labelVoor(el) {
    var item = el.closest('.product-form__item');
    if (item) {
      var lab = item.querySelector('label');
      if (lab && lab.textContent.trim()) return lab.textContent.trim();
    }
    return propertyNaam(el) || 'deze optie';
  }

  // Is er een "met naam"-variant/optie gekozen?
  function metNaamGekozen(form) {
    var gevonden = false;
    var selects = form.querySelectorAll('select[name^="options["]');
    for (var i = 0; i < selects.length; i++) {
      var v = (selects[i].value || '').toString().trim().toLowerCase();
      if (v.indexOf('met naam') !== -1 || /^ja\b/.test(v)) {
        gevonden = true;
        break;
      }
    }
    if (gevonden) return true;
    if (selects.length > 0) return false; // opties aanwezig, maar geen met-naam-keuze

    // Fallback: geselecteerde variant-titel (select[name="id"])
    var varSel = form.querySelector('select[name="id"]');
    if (varSel && varSel.selectedIndex >= 0) {
      var t = (varSel.options[varSel.selectedIndex].textContent || '').trim().toLowerCase();
      if (t.indexOf('met naam') !== -1 || /^ja\b/.test(t)) return true;
    }
    return false;
  }

  /* ---------- foutmeldingen ---------- */
  function wisFouten(form) {
    form.querySelectorAll('.ikmm-pv-fout').forEach(function (el) { el.remove(); });
    form.querySelectorAll('.ikmm-pv-veld-fout').forEach(function (el) { el.classList.remove('ikmm-pv-veld-fout'); });
    form.querySelectorAll('.ikmm-pv-item-fout').forEach(function (el) { el.classList.remove('ikmm-pv-item-fout'); });
  }

  function toonFout(el, tekst, opItem) {
    var fout = document.createElement('span');
    fout.className = 'ikmm-pv-fout';
    fout.setAttribute('role', 'alert');
    fout.textContent = tekst;

    var item = el.closest('.product-form__item');
    if (opItem && item) {
      item.classList.add('ikmm-pv-item-fout');
      item.appendChild(fout);
    } else {
      el.classList.add('ikmm-pv-veld-fout');
      if (el.nextSibling) {
        el.parentNode.insertBefore(fout, el.nextSibling);
      } else {
        el.parentNode.appendChild(fout);
      }
    }
    return fout;
  }

  /* ---------- validatie ---------- */
  function valideer(form) {
    var fouten = [];

    // (a) Naamveld(en): tekstvelden met 'naam' in de property-naam
    var naamVelden = form.querySelectorAll(
      'input[type="text"][name^="properties["], textarea[name^="properties["]'
    );
    naamVelden.forEach(function (veld) {
      if (!isZichtbaar(veld)) return;
      if (propertyNaam(veld).toLowerCase().indexOf('naam') === -1) return;
      if (veld.disabled) return;
      if (!veld.value || !veld.value.trim()) {
        fouten.push({ el: veld, msg: MSG_NAAM, opItem: false });
      }
    });

    // (b) Zichtbare personalisatie-dropdowns die nog op "Kies een optie" staan
    var propSelects = form.querySelectorAll('select[name^="properties["]');
    propSelects.forEach(function (sel) {
      if (!isZichtbaar(sel) || sel.disabled) return;
      var v = (sel.value || '').toString().trim();
      var tekst = sel.selectedIndex >= 0
        ? (sel.options[sel.selectedIndex].textContent || '').trim().toLowerCase()
        : '';
      if (v === '' || tekst === 'kies een optie') {
        fouten.push({ el: sel, msg: MSG_KEUZE_PREFIX + labelVoor(sel), opItem: false });
      }
    });

    // (c) Zichtbare radiogroepen (bijv. properties[Kleur borduring]) zonder keuze
    var radios = form.querySelectorAll('input[type="radio"][name^="properties["]');
    var groepen = {};
    radios.forEach(function (r) {
      var n = r.getAttribute('name');
      if (!groepen[n]) groepen[n] = [];
      groepen[n].push(r);
    });
    Object.keys(groepen).forEach(function (n) {
      var groep = groepen[n];
      var zichtbaar = groep.some(function (r) { return isZichtbaar(r); });
      if (!zichtbaar) return;
      var gekozen = groep.some(function (r) { return r.checked; });
      if (!gekozen) {
        fouten.push({ el: groep[0], msg: MSG_KEUZE_PREFIX + labelVoor(groep[0]), opItem: true });
      }
    });

    return fouten;
  }

  /* ---------- submit-afhandeling ---------- */
  function onSubmit(e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var action = (form.getAttribute('action') || '');
    if (action.indexOf('/cart/add') === -1) return;

    wisFouten(form);
    if (!metNaamGekozen(form)) return; // "Zonder naam"/"Nee": niets afdwingen

    var fouten = valideer(form);
    if (!fouten.length) return;

    e.preventDefault();
    e.stopPropagation();
    injectStyles();

    var eersteEl = null;
    fouten.forEach(function (f, idx) {
      toonFout(f.el, f.msg, f.opItem);
      if (idx === 0) eersteEl = f.el.closest('.product-form__item') || f.el;
    });

    if (eersteEl) {
      try {
        eersteEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {
        eersteEl.scrollIntoView();
      }
      var focusEl = fouten[0].el;
      if (focusEl && typeof focusEl.focus === 'function' && focusEl.type !== 'radio') {
        setTimeout(function () { try { focusEl.focus({ preventScroll: true }); } catch (err) {} }, 350);
      }
    }
  }

  // Fout weghalen zodra het veld wordt ingevuld/gewijzigd
  function onHerstel(e) {
    var el = e.target;
    if (!el || !el.getAttribute) return;
    var naam = el.getAttribute('name') || '';
    if (naam.indexOf('properties[') !== 0 && naam.indexOf('options[') !== 0 && naam !== 'id') return;
    var form = el.closest('form');
    if (!form) return;

    if (el.type === 'radio') {
      var item = el.closest('.product-form__item');
      if (item) {
        item.classList.remove('ikmm-pv-item-fout');
        item.querySelectorAll('.ikmm-pv-fout').forEach(function (f) { f.remove(); });
      }
      return;
    }

    el.classList.remove('ikmm-pv-veld-fout');
    var wrapper = el.closest('.product-form__item') || el.parentNode;
    if (wrapper) {
      wrapper.querySelectorAll('.ikmm-pv-fout').forEach(function (f) { f.remove(); });
    }
    // Bij variantwissel (options/id): alles opnieuw beoordelen bij volgende submit
    if (naam.indexOf('options[') === 0 || naam === 'id') {
      wisFouten(form);
    }
  }

  // Capture-fase zodat dit vóór eventuele andere handlers draait,
  // en ook werkt voor formulieren die later (ajax) worden toegevoegd.
  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('change', onHerstel, true);
  document.addEventListener('input', onHerstel, true);
})();
